import type { ProductEntity } from '../../domain/entities/Product';
import type { IProductRepository } from '../../domain/interfaces';
import type { ProductResponseDTO } from '../dtos/product/ProductResponseDTO';
import type { FindProductsDTO } from '../dtos/product/FindProductsDTO';
import { find } from 'lodash-es';

export interface FindProductsUseCase {
  execute(dto: FindProductsDTO): Promise<ProductResponseDTO[]>;
}

export default class FindProductsUseCaseImpl implements FindProductsUseCase {
  constructor(
    private readonly productRepository: IProductRepository
  ) { }

  async execute(findProductsDTO: FindProductsDTO): Promise<ProductResponseDTO[]> {
    try {
      let products: ProductEntity[];
      
      if (findProductsDTO.sku) {
        console.log('FindProductsUseCaseImpl.execute called with SKU filter');
        const product = await this.productRepository.findBySku(findProductsDTO.sku);
        products = product ? [product] : [];
      } else if (findProductsDTO.barcode) {
        console.log('FindProductsUseCaseImpl.execute called with barcode filter');
        const product = await this.productRepository.findByBarcode(findProductsDTO.barcode);
        products = product ? [product] : [];
      } else if (findProductsDTO.activeOnly) {
        console.log('FindProductsUseCaseImpl.execute called with activeOnly filter');
        products = await this.productRepository.findActive();
      } else {
        console.log('FindProductsUseCaseImpl.execute called without filters');
        products = await this.productRepository.findAll();
      }
console.log('Products found:', products);
      return products.map(product => this.mapToResponseDTO(product));
    } catch (error) {
      throw new Error(`Failed to find products: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }

  private mapToResponseDTO(product: ProductEntity): ProductResponseDTO {
    return {
      id: product.id,
      name: product.name,
      sku: product.sku,
      description: product.description,
      barcode: product.barcode,
      category: product.category,
      cost: product.cost,
      price: product.price,
      minQuantity: product.minQuantity ?? { value: 0, unit: 'unit' },
      maxQuantity: product.maxQuantity,
      isActive: product.isActive,
      createdAt: product.createdAt,
      updatedAt: product.updatedAt
    };
  }
}
